import { BuzzPromoCard } from '@/features/buzz/components/BuzzPromoCard'
import { ProfileInfoBlock } from '@/features/profile/ProfileInfoBlock'
import { ReferralProgramBanner } from '@/features/referrals/components/ReferralProgramBanner'

/**
 * The dashboard's sidebar column (a wrapping row at tablet width).
 *
 * `hasAnyWorkers` comes in as a prop rather than from `useFetchWorkers`, because
 * `Dashboard` already owns the one workers query.
 */
export function DashboardSidebar(props: { hasAnyWorkers: boolean }): React.JSX.Element {
  return (
    <div className="max-tablet:flex-row max-tablet:flex-wrap max-tablet:pr-0 max-mobile:flex-col flex flex-col justify-between gap-4 pr-10">
      <ProfileInfoBlock />
      <BuzzPromoCard />
      {props.hasAnyWorkers && <ReferralProgramBanner />}
    </div>
  )
}
